import React, { useEffect, useState } from 'react';
import QuoteDetail from '@system/config/quote';
import Helper from 'src/helper/Helper';
import { useQuoteStore } from "../../hooks/quote";
import Pagination from "src/component/Global/Pagination"
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import NoResultContent from '../HomePageContent/NoResultContent';
import Constants from 'src/helper/Constants';
import produceClone from 'src/helper/produceClone';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import System from 'src/helper/system';
import liveAuth from 'src/helper/liveAuth';
import { __remove, __set } from "../../store/axios_indicator";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";


export function SubmittedQuoteList() {
  const [__check] = useAxiosIndicatorCheck();
  const [{ submittedQuoteList }, { fetch_submitted_quote_list, fetch_submitted_quote_export_url, }, { }] = useQuoteStore();
  const [list, setList] = useState([]);
  const [listObj, setListObj] = useState({
    pageCount: 0,
    page: 1,
    limit: 20,
    sortBy: '',
    sortOrder: '',
    ascDesField: {}
  })
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
  const [headerDistance, setHeaderDistance] = useState(0);
  const { downloadMsg, noValue } = Constants

  const setPageLimit = async (event) => {
    setListObj({ ...listObj, limit: Number(event.target.value), page: 1 });
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [list])

  useEffect(() => {
    async function fetchHere() {
      setFirstServerCall(false)
      fetchAPICall()
    }

    fetchHere();
  }, [listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder]);

  useEffect(() => {
    if (submittedQuoteList && Object.keys(submittedQuoteList).length > 0) {
      setList(submittedQuoteList.records)
      setListObj({ ...listObj, pageCount: Math.ceil(submittedQuoteList?.count / listObj.limit) })
    } else {
      setList([])
      setListObj({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
      })
    }
    if (firstServerCall === false && liveAuth.check() && !monitorFunctionCall) {
      System.monitorJSDx()
      setMonitorFunctionCall(true)
    }
  }, [submittedQuoteList]);

  const fetchAPICall = async () => {
    __set('QUOTE_API_CALL');
    await fetch_submitted_quote_list({
      "pageNumber": listObj.page,
      "pageSize": listObj.limit,
      "sortBy": listObj.sortBy,
      "sortType": listObj.sortOrder,
      "requiredAddressDetails": false
    })
    __remove('QUOTE_API_CALL')
  };

  const manageLoad = (loadVal, quoteNumber) => {
    const _cloneObject = produceClone(list);
    const newList = _cloneObject.map((item) => {
      if (item.quoteNumber === quoteNumber) {
        return {
          ...item,
          isLoad: loadVal,
        };
      }
      return item;
    });
    setList(newList);
  }
  const onSelectOption = async (e, ele) => {
    if (e.target.value !== '') {
      manageLoad(true, ele.quoteNumber)
      const result = await fetch_submitted_quote_export_url({
        "quoteNumber": ele.quoteNumber,
        "fileType": e.target.value,
        "quoteExpirationDate": Helper.valueIsNotNull(ele?.quoteExpirationDate) ? Helper.convertDateFormatToMMDDYYYY(ele.quoteExpirationDate) : null,
        "customerQuoteNumber": Helper.valueIsNotNull(ele?.customerQuoteNumber) ? ele.customerQuoteNumber : null
      })
      manageLoad(false, ele.quoteNumber)
      exportEvent(e.target.value,ele)
    }
  };

  //By Ramya [Export Event - Cart ADobe script]
  function exportEvent(type, quote){
    localStorage.setItem("adobeEventType","exportEvent");
    let exportDetails = {
      fileExtension : type,
      exportType: "Quote"
    }
    let QuoteDetails = {
        quoteID:quote.quoteNumber,
        quoteType:quote.quoteSource
    };
    if(Object.keys(exportDetails).length && Object.keys(QuoteDetails).length) {
        HelperAdobeEvent.trackingAdobeEvent({QuoteDetails,exportDetails});
    }

  }
   

  const handlePageClick = async (data) => {
    setListObj({ ...listObj, page: (data.selected + 1) });
    Helper.scrollTop();
  };

  const toggleOrderBy = async (columnName) => {
    if (listObj.ascDesField.hasOwnProperty(columnName)) {
      listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DSC' : 'ASC';
    } else {
      listObj.ascDesField[columnName] = 'ASC'
    }
    setListObj({
      ...listObj,
      sortBy: columnName,
      sortOrder: listObj.ascDesField[columnName],
      ascDesField: listObj.ascDesField
    })
  };

  const getOrderByClass = (columnName) => {
    if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
      return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
    }
    return 'sorting'
  };

  useEffect(() => {
    const handleScroll = () => {
      const tableHeader = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight - 1 : 65 + 1
      if (tableHeader) {
        setHeaderDistance(tableHeader);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>

      {__check(['QUOTE_API_CALL']).status ? __check(["QUOTE_API_CALL"]).render :
        (list && list.length > 0 ? <div className='position-relative mx-3'>
          {/* <div> */}
          {/*    {__check(['QUOTE_API_CALL'], { overlay: true }).render} */}
          {/* </div> */}
          <div className="submitted-quote-table mb-5">
            <div className="sticky-table-wrapper">
              <table className="bs5 table table-bordered table-striped">
                <thead style={{ position: 'sticky', top: headerDistance, zIndex: '1' }}>
                  <tr>
                    <th className='w155'></th>
                    <th>
                      <span>Quote Number</span>
                      <span aria-label='quoteNumber' className={'sort-container ' + getOrderByClass('quoteNumber')}
                        onClick={async () => { await toggleOrderBy('quoteNumber') }}></span>
                    </th>

                    <th><span>Date Requested</span>
                      <span aria-label='quoteRequestedDate'
                        className={'sort-container ' + getOrderByClass('quoteRequestedDate')}
                        onClick={async () => {
                          await toggleOrderBy('quoteRequestedDate')
                        }}></span>
                    </th>
                    <th><span>Expiration</span>
                      <span aria-label='QUOTEEXPIRYDATE'
                        className={'sort-container ' + getOrderByClass('QUOTEEXPIRYDATE')}
                        onClick={async () => {
                          await toggleOrderBy('QUOTEEXPIRYDATE')
                        }}></span>
                    </th>
                    <th><span>Origination</span>
                      <span aria-label='QUOTESOURCE'
                        className={'sort-container ' + getOrderByClass('QUOTESOURCE')}
                        onClick={async () => {
                          await toggleOrderBy('QUOTESOURCE')
                        }}>
                      </span>
                    </th>
                    <th><span>Buyer</span>
                      <span aria-label='Buyer'
                        className={'sort-container ' + getOrderByClass('Buyer')}
                        onClick={async () => {
                          await toggleOrderBy('Buyer')
                        }}></span>
                    </th>
                    <th><span>Project Name</span>
                      <span aria-label='projectName'
                        className={'sort-container ' + getOrderByClass('projectName')}
                        onClick={async () => {
                          await toggleOrderBy('projectName')
                        }}></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {list && list.length > 0 && list.map((v, i) => (
                    <React.Fragment key={i}>
                      <tr>
                        <td>
                          {v.quoteNumber?.trim() ?
                            <div className="dropdown">
                              {v.isLoad &&
                                <AxiosIndicatorRunTimeLoader />
                              }
                              {v.isLoad === false &&
                                <div className="selectbox">
                                  <select className="form-control form-control-sm"
                                    key={v.quoteNumber}
                                    onChange={(e) => onSelectOption(e, v)}>
                                    <option value=''>Options</option>
                                    <option value='xlsx'>Export XLSX</option>
                                    <option value='csv'>Export CSV</option>
                                  </select>
                                </div>
                              }
                            </div>
                            : <div className='text-center'>——</div>}
                        </td>

                        <td>
                          {v.quoteNumber?.trim() ?
                            <a href={QuoteDetail.getQuoteDetailPageRouteURL({ quote_number: v.quoteNumber, })}> {v.displayQuoteNumber + '-' + v.quoteRevisionNumber}</a> : "In Process"}
                        </td>
                        <td>{(v.quoteRequestedDate && v.quoteRequestedDate !== "00000000") ? Helper.dateFormatFromString(v.quoteRequestedDate) : noValue}</td>
                        <td>{v.quoteExpirationDate && v.quoteExpirationDate !== "00000000" ? Helper.dateFormatFromString(v.quoteExpirationDate) : noValue}</td>
                        <td>
                          {Helper.valueIsNotNull(v.originated) ? v.originated : noValue}</td>
                        <td>{Helper.valueIsNotNull(v.buyer) ? v.buyer : noValue}</td>
                        <td>{Helper.valueIsNotNull(v.projectName) ? v.projectName : noValue}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick}
            setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
        </div>
          : <NoResultContent message={"Sorry! No Result Found. We can't find any results based on your selection."} isDisplay={false} />)}
    </>);
}
